import { Link } from "react-router-dom";
import { copy } from "../copy";
import BrandLogo from "./BrandLogo";

export default function SiteFooter() {
  return (
    <footer className="border-t border-gold/25 bg-ground-raised px-4 pb-10 pt-16 md:px-6 md:pb-14 md:pt-20">
      <div className="mx-auto w-full max-w-[1240px]">
        <div className="flex flex-col gap-10 lg:flex-row lg:justify-between lg:gap-16">
          <div className="max-w-xl">
            <BrandLogo className="h-12 md:h-14" />
            <p className="mt-5 text-sm leading-relaxed text-chrome-dim">{copy.footer.skill}</p>
            <p className="mt-4 text-xs leading-relaxed text-chrome-dim">{copy.footer.credits}</p>
          </div>
          <div>
            <p className="text-[11px] uppercase tracking-[0.2em] text-chrome-dim">{copy.footer.elsewhere}</p>
            <div className="mt-4 flex flex-col gap-3">
              <Link
                to="/how-it-works"
                className="bf-focusable w-fit text-xs uppercase tracking-[0.16em] text-chrome-dim transition-colors hover:text-chrome"
              >
                {copy.footer.howItWorks} →
              </Link>
              <Link
                to="/websites-for-producers"
                className="bf-focusable w-fit text-xs uppercase tracking-[0.16em] text-chrome-dim transition-colors hover:text-chrome"
              >
                {copy.footer.websites} →
              </Link>
            </div>
          </div>
        </div>
        <div className="mt-14 border-t border-ground-edge pt-6">
          <p className="text-[11px] uppercase tracking-[0.16em] text-chrome-dim">{copy.footer.rights}</p>
        </div>
      </div>
    </footer>
  );
}
